import {
  coerceDriverBlobToUint8Array,
  decodeCompactGraphemeStrokes,
  encodeCompactGraphemeStrokes,
  type UnpackedGraphemeStrokes,
} from "@-/dev.improve.haniverse.lib.morpheme.grapheme.strokes";
import { customType } from "@-/com.npmjs.drizzle-orm/sqlite-core";

const graphemeStrokesJsonColumnType = customType<{
  data: UnpackedGraphemeStrokes[];
  driverData: Uint8Array;
}>({
  // drizzle-orm 1.0.0-rc.5 only `hex()`es a blob inside relational JSON when the column names its
  // codec (SQLite's `json_object` rejects BLOBs). The codec decodes the hex back to bytes before
  // `fromDriver`, so both paths hand it a Uint8Array.
  codec: "blob",
  dataType() {
    return "blob";
  },
  fromDriver(value) {
    const bytes = coerceDriverBlobToUint8Array(value);
    if (bytes === null) {
      return [];
    }
    return decodeCompactGraphemeStrokes(bytes) ?? [];
  },
  toDriver(value) {
    return encodeCompactGraphemeStrokes(value);
  },
});

export function graphemeStrokesJsonColumn<Name extends string>(name: Name) {
  return graphemeStrokesJsonColumnType(name);
}
